import Button from "@app/components/button";
import UpgradeItem from "@app/components/upgrade-item";
import { Upgrade } from "@app/types";
import { Images } from "@assets/images";
import { UpgradeStep } from "../upgrade.page";

interface StepOneProps {
  packageIdSelected?: number;
  upgrades: Upgrade[];
  handlePackageClick: (packageId: number) => void;
  handleSetStep: (step: UpgradeStep) => void;
}

function StepOne({
  packageIdSelected,
  upgrades,
  handlePackageClick,
  handleSetStep,
}: StepOneProps) {
  const handleContinueClick = () => {
    handleSetStep(UpgradeStep.TWO);
  };

  return (
    <>
      <div className="flex gap-6 justify-center flex-wrap mt-16">
        {upgrades.map((item) => (
          <div key={item.id} onClick={() => handlePackageClick(item.id)}>
            <UpgradeItem
              upgrade={item}
              isChecked={packageIdSelected === item.id}
            />
          </div>
        ))}
      </div>
      <div className="flex justify-center">
        <div className="w-[608px] bg-white mt-10 rounded-2xl pt-6 pb-8 px-7 flex justify-between">
          <div className="flex flex-col">
            <div className="font-semibold font-[SVN-Gilroy] text-[#2A2A2A]">
              Tính năng
            </div>
            <div className="mt-7 font-[SVN-Gilroy] text-[#4E586C] tracking-[0.024px]">
              Loại bỏ quảng cáo gây phiền
            </div>
            <div className="mt-4 font-[SVN-Gilroy] text-[#4E586C] tracking-[0.024px]">
              Nghe & Tải nội dung VIP
            </div>
            <div className="mt-4 font-[SVN-Gilroy] text-[#4E586C] tracking-[0.024px]">
              Đọc và nghe không giới hạn
            </div>
            <div className="mt-4 font-[SVN-Gilroy] text-[#4E586C] tracking-[0.024px]">
              Đội ngũ hỗ trợ của chúng tôi
            </div>
          </div>
          <div className="flex gap-[68px]">
            <div className="flex flex-col items-center">
              <div className="font-semibold font-[SVN-Gilroy] text-[#2A2A2A]">
                Tháng
              </div>
              <div className="mt-7">
                <img src={Images.Line.default} alt="" />
              </div>
              <div className="mt-4">
                <img src={Images.CheckIcon.default} alt="" />
              </div>
              <div className="mt-4">
                <img src={Images.CheckIcon.default} alt="" />
              </div>
              <div className="mt-4">
                <img src={Images.CheckIcon.default} alt="" />
              </div>
            </div>
            <div className="flex flex-col items-center">
              <div className="font-semibold font-[SVN-Gilroy] text-[#2A2A2A]">
                Năm
              </div>
              <div className="mt-7">
                <img src={Images.CheckIcon.default} alt="" />
              </div>
              <div className="mt-4">
                <img src={Images.CheckIcon.default} alt="" />
              </div>
              <div className="mt-4">
                <img src={Images.CheckIcon.default} alt="" />
              </div>
              <div className="mt-4">
                <img src={Images.CheckIcon.default} alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-5 text-center font-[SVN-Gilroy] font-medium">
        {"Khi tham gia, bạn đồng ý với "}
        <a
          className="text-[#4558FF] font-[SVN-Gilroy] no-underline"
          target="_blank"
          href="https://bookas.vn/policies/"
          rel="noreferrer"
        >
          chính sách quyền riêng tư
        </a>
        {" và "}
        <a
          className="text-[#4558FF] font-[SVN-Gilroy] no-underline"
          target="_blank"
          href="https://bookas.vn/rules/"
          rel="noreferrer"
        >
          điều khoản dịch vụ
        </a>
        {" của chúng tôi"}
      </div>
      <Button
        width="auto"
        className="!w-[398px] mt-[76px] !h-12 font-bold bg-gradient-to-b from-[#49C172] to-[#288564] !rounded-[24px]"
        label="Tiếp tục"
        labelClassName="font-[SVN-Gilroy] text-lg tracking-[0.027px]"
        containerClassName="flex justify-center"
        disabled={!packageIdSelected}
        onClick={handleContinueClick}
      />
    </>
  );
}

export default StepOne;
